import React from "react";
import { useState } from "react";

import imageOne from "../../../assets/lesson 9.1.png";
import imageTwo from "../../../assets/lesson 9.2.png";

function LessonNine() {
  const [q1, setQ1] = useState("");
  const [q2, setQ2] = useState("");
  const [q3, setQ3] = useState("");
  const [q4, setQ4] = useState("");
  const [q5, setQ5] = useState("");
  const [q6, setQ6] = useState("");
  const [q7, setQ7] = useState("");
  const [q8, setQ8] = useState("");
  const [q9, setQ9] = useState("");
  const [q10, setQ10] = useState("");
  const [q11, setQ11] = useState("");
  const [q12, setQ12] = useState("");
  const [q13, setQ13] = useState("");
  const [q14, setQ14] = useState("");
  const [q15, setQ15] = useState("");
  const [q16, setQ16] = useState("");
  const [q17, setQ17] = useState("");
  const [q18, setQ18] = useState("");
  const [q19, setQ19] = useState("");
  const [q20, setQ20] = useState("");
  const [q21, setQ21] = useState("");
  const [q22, setQ22] = useState("");
  const [q23, setQ23] = useState("");
  const [q24, setQ24] = useState("");
  const [q25, setQ25] = useState("");
  const [q26, setQ26] = useState("");
  const [q27, setQ27] = useState("");
  const [q28, setQ28] = useState("");
  const [q29, setQ29] = useState("");
  const [q30, setQ30] = useState("");
  const [q31, setQ31] = useState("");
  const [q32, setQ32] = useState("");
  const [q33, setQ33] = useState("");
  const [q34, setQ34] = useState("");
  const [q35, setQ35] = useState("");
  const [q36, setQ36] = useState("");
  const [q37, setQ37] = useState("");
  const [q38, setQ38] = useState("");
  const [q39, setQ39] = useState("");
  const [q40, setQ40] = useState("");
  return (
    <>
      <div className="">
        <div className="task-one mb-3">
          <h4>
            <span>9.1</span> Answer the questions about the pictures.
          </h4>
          <p className="table row">
            <img
              src={imageOne}
              alt="a photo that shows two activities. A man having a bath and a woman playing the piano."
            />
            <ul className="row">
              <li>
                1 - Does he take photographs?
                <input
                  className="border"
                  value="Yes, he does."
                  disabled
                  style={{ background: "#198754", color: "white" }}
                />
              </li>
              <li>
                Is he taking a photograph?
                <input
                  className="border"
                  value="No, he isn't."
                  disabled
                  style={{ background: "#198754", color: "white" }}
                />
              </li>
              <li>
                What is he doing?
                <input
                  className="border"
                  value="He's having a bath."
                  disabled
                  style={{ background: "#198754", color: "white" }}
                />
              </li>
              <li>
                2 - Is she driving a bus?
                <input
                  className="border"
                  onChange={(e) => setQ1(e.target.value)}
                  style={{
                    background:
                      q1.trim() === "No, she isn't." ? "#198754" : "white",
                    color: q1.trim() === "No, she isn't." ? "white" : "black",
                  }}
                />
              </li>
              <li>
                Does she drive a bus?
                <input
                  className="border"
                  onChange={(e) => setQ2(e.target.value)}
                  style={{
                    background:
                      q2.trim() === "Yes, she does." ? "#198754" : "white",
                    color: q2.trim() === "Yes, she does." ? "white" : "black",
                  }}
                />
              </li>
              <li>
                What is she doing?
                <input
                  className="border"
                  onChange={(e) => setQ3(e.target.value)}
                  style={{
                    background:
                      q3.trim() === "She is playing the piano."
                        ? "#198754"
                        : "white",
                    color:
                      q3.trim() === "She is playing the piano."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <img src={imageTwo} alt="" />
              <li>
                3 - Does he clean windows?
                <input
                  className="border"
                  onChange={(e) => setQ4(e.target.value)}
                  style={{
                    background:
                      q4.trim() === "Yes, he does." ? "#198754" : "white",
                    color: q4.trim() === "Yes, he does." ? "white" : "black",
                  }}
                />
              </li>
              <li>
                Is he cleaning a window?
                <input
                  className="border"
                  onChange={(e) => setQ5(e.target.value)}
                  style={{
                    background:
                      q5.trim() === "Yes, he is." ? "#198754" : "white",
                    color: q5.trim() === "Yes, he is." ? "white" : "black",
                  }}
                />
              </li>
              <li>
                What is he doing?
                <input
                  className="border"
                  onChange={(e) => setQ6(e.target.value)}
                  style={{
                    background:
                      q6.trim() === "He is cleaning a window."
                        ? "#198754"
                        : "white",
                    color:
                      q6.trim() === "He is cleaning a window."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                4 - Are they teaching?
                <input
                  className="border"
                  onChange={(e) => setQ7(e.target.value)}
                  style={{
                    background:
                      q7.trim() === "No, they aren't." ? "#198754" : "white",
                    color: q7.trim() === "No, they aren't." ? "white" : "black",
                  }}
                />
              </li>
              <li>
                Do they teach?
                <input
                  className="border"
                  onChange={(e) => setQ8(e.target.value)}
                  style={{
                    background:
                      q8.trim() === "Yes, they do." ? "#198754" : "white",
                    color: q8.trim() === "Yes, they do." ? "white" : "black",
                  }}
                />
              </li>
              <li>
                What do they do?
                <input
                  className="border"
                  onChange={(e) => setQ9(e.target.value)}
                  style={{
                    background:
                      q9.trim() === "They teach." ? "#198754" : "white",
                    color: q9.trim() === "They teach." ? "white" : "black",
                  }}
                />
              </li>
            </ul>
          </p>
        </div>

        <hr />

        <div className="task-two mb-3">
          <h4>
            <span>9.2</span> Complete the sentences with
            <strong>am / is / are </strong> or{" "}
            <strong>do / don't / does / doesn't.</strong>
          </h4>
          <p className="table row">
            <ol className="">
              <li>
                Execuse me,
                <input
                  className="border"
                  value="do"
                  disabled
                  style={{
                    background: "#198754",
                    color: "white",
                  }}
                />
                you speak English?
              </li>
              <li>
                'Where's Kate?' 'I
                <input
                  className="border"
                  onChange={(e) => setQ10(e.target.value)}
                  style={{
                    background: q10.trim() === "don't" ? "#198754" : "white",
                    color: q10.trim() === "don't" ? "white" : "black",
                  }}
                />
                know.'
              </li>
              <li>
                What's funny? Why
                <input
                  className="border"
                  onChange={(e) => setQ11(e.target.value)}
                  style={{
                    background: q11.trim() === "are" ? "#198754" : "white",
                    color: q11.trim() === "are" ? "white" : "black",
                  }}
                />
                you laughing?
              </li>
              <li>
                'What
                <input
                  className="border"
                  onChange={(e) => setQ12(e.target.value)}
                  style={{
                    background: q12.trim() === "does" ? "#198754" : "white",
                    color: q12.trim() === "does" ? "white" : "black",
                  }}
                />
                your sister do?' 'She's a dentist.'
              </li>
              <li>
                It
                <input
                  className="border"
                  onChange={(e) => setQ13(e.target.value)}
                  style={{
                    background: q13.trim() === "is" ? "#198754" : "white",
                    color: q13.trim() === "is" ? "white" : "black",
                  }}
                />
                raining. I
                <input
                  className="border"
                  onChange={(e) => setQ14(e.target.value)}
                  style={{
                    background: q14.trim() === "don't" ? "#198754" : "white",
                    color: q14.trim() === "don't" ? "white" : "black",
                  }}
                />{" "}
                want to go out in the rain.
              </li>
              <li>
                'Where
                <input
                  className="border"
                  onChange={(e) => setQ15(e.target.value)}
                  style={{
                    background: q15.trim() === "do" ? "#198754" : "white",
                    color: q15.trim() === "do" ? "white" : "black",
                  }}
                />
                you come from?' 'Canada.'
              </li>
              <li>
                How much
                <input
                  className="border"
                  onChange={(e) => setQ16(e.target.value)}
                  style={{
                    background: q16.trim() === "does" ? "#198754" : "white",
                    color: q16.trim() === "does" ? "white" : "black",
                  }}
                />
                it cost to stay at this hotel? Is it expensive?
              </li>
              <li>
                Steve is a good tennis player, but he
                <input
                  className="border"
                  onChange={(e) => setQ17(e.target.value)}
                  style={{
                    background: q17.trim() === "doesn't" ? "#198754" : "white",
                    color: q17.trim() === "doesn't" ? "white" : "black",
                  }}
                />
                play very often.
              </li>
            </ol>
          </p>
        </div>

        <hr />

        <div className="task-three mb-3 row ">
          <h4>
            <span>9.3</span> Put the verb in the present continuous (
            <strong> I am doing </strong>) or the present simple (
            <strong> I do </strong>)
          </h4>
          <p className="table row">
            <div className="row">
              <ol>
                <li>
                  Excuse me,
                  <input
                    className="border"
                    value="do you speak"
                    disabled
                    style={{
                      background: "#198754",
                      color: "white",
                    }}
                  />
                  (you/speak) English?
                </li>
                <li>
                  'Where's Tom?' '
                  <input
                    className="border"
                    value="He's having"
                    style={{
                      background: "#198754",
                      color: "white",
                    }}
                  />
                  (he/have) a shower.'
                </li>
                <li>
                  <input
                    className="border"
                    value="I don't watch"
                    style={{
                      background: "#198754",
                      color: "white",
                    }}
                  />
                  (I / not / watch) TV very often.
                </li>
                <li>
                  Listen! Somebody
                  <input
                    className="border"
                    onChange={(e) => setQ18(e.target.value)}
                    style={{
                      background:
                        q18.trim() === "is singing" ? "#198754" : "white",
                      color: q18.trim() === "is singing" ? "white" : "black",
                    }}
                  />
                  (sing).
                </li>
                <li>
                  Sarah is tired.
                  <input
                    className="border"
                    onChange={(e) => setQ19(e.target.value)}
                    style={{
                      background:
                        q19.trim() === "She wants" ? "#198754" : "white",
                      color: q19.trim() === "She wants" ? "white" : "black",
                    }}
                  />
                  (she / want) to go home now.
                </li>
                <li>
                  How often
                  <input
                    className="border"
                    onChange={(e) => setQ20(e.target.value)}
                    style={{
                      background:
                        q20.trim() === "do you use" ? "#198754" : "white",
                      color: q20.trim() === "do you use" ? "white" : "black",
                    }}
                  />
                  (you / use) your car? Every day?
                </li>
                <li>
                  'Excuse me, but
                  <input
                    className="border"
                    onChange={(e) => setQ21(e.target.value)}
                    style={{
                      background:
                        q21.trim() === "you are sitting" ? "#198754" : "white",
                      color:
                        q21.trim() === "you are sitting" ? "white" : "black",
                    }}
                  />
                  (you / sit) in my seat.' 'Oh, I'm sorry.'
                </li>
                <li>
                  I'm sorry,
                  <input
                    className="border"
                    onChange={(e) => setQ22(e.target.value)}
                    style={{
                      background:
                        q22.trim() === "I don't uderstand"
                          ? "#198754"
                          : "white",
                      color:
                        q22.trim() === "I don't uderstand" ? "white" : "black",
                    }}
                  />
                  (I / not / uderstand). Can you speak more slowly?
                </li>
                <li>
                  It's late.
                  <input
                    className="border"
                    onChange={(e) => setQ23(e.target.value)}
                    style={{
                      background:
                        q23.trim() === "I am going home now."
                          ? "#198754"
                          : "white",
                      color:
                        q23.trim() === "I am going home now."
                          ? "white"
                          : "black",
                    }}
                  />
                  (I / go) home now.
                  <input
                    className="border"
                    onChange={(e) => setQ24(e.target.value)}
                    style={{
                      background:
                        q24.trim() === "Are you coming" ? "#198754" : "white",
                      color:
                        q24.trim() === "Are you coming" ? "white" : "black",
                    }}
                  />
                  (you / come) with me?
                </li>
                <li>
                  What time
                  <input
                    className="border"
                    onChange={(e) => setQ25(e.target.value)}
                    style={{
                      background:
                        q25.trim() === "does your father" ? "#198754" : "white",
                      color:
                        q25.trim() === "does your father" ? "white" : "black",
                    }}
                  />
                  (your father / finish) work every day?
                </li>
                <li>
                  You can turn off the radio.
                  <input
                    className="border"
                    onChange={(e) => setQ26(e.target.value)}
                    style={{
                      background:
                        q26.trim() === "I am not listening"
                          ? "#198754"
                          : "white",
                      color:
                        q26.trim() === "I am not listening" ? "white" : "black",
                    }}
                  />
                  (I / not / listen) to it.
                </li>
                <li>
                  'Where's Paul?' 'In the kitchen.
                  <input
                    className="border"
                    onChange={(e) => setQ27(e.target.value)}
                    style={{
                      background:
                        q27.trim() === "He is cooking" ? "#198754" : "white",
                      color: q27.trim() === "He is cooking" ? "white" : "black",
                    }}
                  />
                  (he / cook) something.'
                </li>
              </ol>
            </div>
          </p>
        </div>
      </div>
    </>
  );
}

export default LessonNine;
